import {
  FieldLabel,
  FormSection,
  GuaranteePills,
} from "../../../../components/propertyDescription/descriptionUi";
import { buildGuaranteeToggleEvent } from "../../../../utils/guaranteeSelection";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";

export default function GuaranteesSection() {
  const {
    guarantees,
    propertyHasGuarantee,
    onGuaranteeSelectedHandler,
    formErrors,
  } = useEditPropertyWizard();

  return (
    <FormSection
      title="Garantias"
      description="Selecione ao menos uma garantia aceita na locação."
    >
      <FieldLabel error={formErrors.guarantees}>Garantias disponíveis</FieldLabel>
      <GuaranteePills
        items={guarantees ?? []}
        isSelected={propertyHasGuarantee}
        onToggle={(id, selected) =>
          onGuaranteeSelectedHandler(buildGuaranteeToggleEvent(id, selected))
        }
      />
    </FormSection>
  );
}
